/*
 * Copyright 2022 StarTree Inc.
 *
 * All rights reserved. Confidential and proprietary information of StarTree Inc.
 */
export interface UserOrganization {
    id: string;
    user: OrganizationUser;
    roles: OrganizationRole[];
}

export interface OrganizationUser {
    id: string;
    name: string;
    email: string;
}

export enum OrganizationRole {
    ADMIN = "ADMIN",
}

export interface PlatformUser {
    id: string;
    name: string;
    email: string;
    roles: PlatformRole[];
}

export enum PlatformRole {
    ROLE_saas_users = "ROLE_saas_users",
    ROLE_admin = "ROLE_admin",
}

export interface UserInvite {
    organizationId: string;
    email: string;
    roles: OrganizationRole[];
}

export enum CloudVersion {
    V1 = "V1",
    V2 = "V2",
}

export interface OnboardCloudV2TrialUserResponse {
    status: OnboardCloudV2TrialEnvironmentStatus;
    dmUrl: string;
    appsUrl: string;
    qcUrl: string;
    teUrl?: string;
}

export enum OnboardCloudV2TrialEnvironmentStatus {
    OK = "ok",
    PENDING = "pending",
}

export interface InvitedCloudV2TrialUser {
    email: string;
}
